/**
 * MFA Required page — used during the OAuth flow.
 *
 * When the /api/oauth/authorize endpoint detects that a client (e.g. Money)
 * requires MFA but the user hasn't enrolled at all, it redirects here:
 *
 *   /mfa-required?client_id=nacho-money&redirect_uri=...&state=...
 *
 * Unlike /mfa-challenge (which collects a code from an already-enrolled user),
 * this page can't resume the flow — the user has no authenticator set up yet.
 * It's purely informational: it sends them to their profile to enable MFA,
 * after which they can sign into the client again.
 */

import { useNavigate } from 'react-router-dom';

import { usePageTitle } from '../hooks/usePageTitle.js';
import './LoginPage.css';   // reuse the login card styles


export default function MfaRequiredPage() {
  usePageTitle('MFA required');

  const navigate = useNavigate();

  return (
    <div className="login-page">
      <header className="login-top" aria-hidden="true" />

      <main className="login-stage">
        <section className="login-card">
          <div className="login-card-head">
            <span className="login-sticker">🔐 setup required</span>
            <h1 className="login-title">MFA Required</h1>
            <p className="login-sub">
              Nacho Money requires two-factor authentication. Please enable MFA
              on your profile, then sign in again.
            </p>
          </div>

          <button
            type="button"
            className="login-submit"
            onClick={() => navigate('/profile')}
          >
            go to profile  →
          </button>

          <button
            type="button"
            className="login-back-btn"
            onClick={() => navigate('/')}
          >
            back to home
          </button>
        </section>
      </main>

      <div className="login-tagline">
        <strong>NachoFiles</strong> — the reason the chicken crossed the road
      </div>
    </div>
  );
}
